import React, { useState } from "react";
import PlusProfileImage from "./PlusProfileImage";
import ProfileImage from "./ProfileImage";

import Slider from "react-slick";
function ProfilesBar(props) {
  const [canChange, setChange] = useState(false);
  //let fgColor = "white";
  //let bgColor = "#7FBCE1";
  function AlreadyActive() {
    // console.log("Already Active");
  }
  let profiles = props.profileData.Profiles;
  let settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    vertical: true,
  };
  let settings2 = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    vertical: true,
  };
  let activeProfObj = props.activeProfile;
  function HandleChange() {
    setChange(!canChange);
  }
  return (
    <div className="profileBarContainer">
      <div className="greeting">
        Hello, {props.activeProfile.Name}, {"  "}
      </div>
      <div>
        <div className="greeting changeButton" onClick={HandleChange}>
          Change Profile
        </div>
      </div>

      {canChange ? (
        <div className="Vertibar">
          <div className="profileButtonContainer">
            <div></div>
            <ProfileImage
              color={activeProfObj.ProfileIMGFG}
              backgroundColor={activeProfObj.ProfileIMGBG}
              SetProfile={AlreadyActive}
              isActive={true}
            >
              {activeProfObj.Name}
            </ProfileImage>
          </div>
          <div className="profileButtonContainer">
            <PlusProfileImage />
          </div>
          <div className="profileButtonContainer">
            {profiles.length > 4 ? (
              <Slider {...settings2}>
                {profiles.map((prof) => {
                  if (prof.Name !== props.activeProfile.Name) {
                    return (
                      <div key={prof.Name}>
                        <ProfileImage
                          color={prof.ProfileIMGFG}
                          prof={prof}
                          SetProfile={props.SetProfile}
                          backgroundColor={prof.ProfileIMGBG}
                        >
                          {prof.Name}
                        </ProfileImage>
                      </div>
                    );
                  } else {
                    return;
                  }
                })}
              </Slider>
            ) : (
              <Slider {...settings}>
                {profiles.map((prof) => {
                  if (prof.Name !== props.activeProfile.Name) {
                    return (
                      <div key={prof.Name}>
                        <ProfileImage
                          color={prof.ProfileIMGFG}
                          prof={prof}
                          SetProfile={props.SetProfile}
                          backgroundColor={prof.ProfileIMGBG}
                        >
                          {prof.Name}
                        </ProfileImage>
                      </div>
                    );
                  } else {
                    return;
                  }
                })}
              </Slider>
            )}
          </div>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
}

export default ProfilesBar;
